import AdvancedController from "./advanced-controller"
// import gsap from 'gsap'
// import throttle from 'just-throttle';

import Hunt from 'huntjs';

// export const InView = () => {
//   const els = document.querySelectorAll('.-detect-in-viewport');
//   new Hunt(els, {
//     enter: (el) => {
//       el.classList.add('-in-viewport');
//     },
//   });
// };

const isEmpty = (obj) => {
  return !!obj === false || Object.keys(obj).length === 0
}
export default class OnPageNavController extends AdvancedController {

  static targets = [
    "section",
  ]

  static values = {
    // active: {
    //   type: Object,
    //   default: {}
    // }
  }

  static active = null

  connect() {
    super.connect(...arguments)

    const scenes = document.querySelectorAll("[id^='scene']")
    new Hunt(scenes, {
      persist: true,
      offset: 0,
      enter: (el) => {
        if (el != this.active) {
          // handle the active state of the scene
          if (!isEmpty(this.active))
            this.active.classList.remove('-active')
          this.active = el
          this.active.classList.add('-active')
          // handle the active state of the on page nav
          // --- remove old active
          const navActiveBefore = document.querySelector('.home__on-page__nav .-active')
          if (navActiveBefore) navActiveBefore.classList.remove('-active')
          // --- add new active
          const id = this.active.getAttribute('id')
          const navEl = document.querySelector(`[href="#${id}"]`)
          navEl.classList.add('-active')
        }
      }
    })
  }
}